module.exports = __webpack_public_path__ + "img/lang.3a506c2b.png";